export default {
  type: 'quote',
  title: `Pull Quote`,
  icon: `quote-left`,
  template: `
        <div contenteditable="false" feature-obj="feature" org-index="orgIndex" class="">
          <blockquote>
            <p  ng-repeat="el in feature.content_elements track by $index">
            {{el.content}}
            </p>
            <em>{{feature.citation.content}}</em>
          </blockquote>
        </div>`,
  propertyTemplate: `<quote-property-editor feature="feature"/>`,
  initialInflation: function () {
    return {
      type: 'quote',
      subtype: 'pullquote',
      subtype_label: 'Pull quote',
      content_elements: [{ type: 'text', content: '' }],
      citation: {
        type: 'text',
        content: '',
      },
    }
  },
  openPropertyTemplateOnAdd: true,
}
